module.exports = __webpack_public_path__ + "static/media/019-mouth.dc0f77e0.svg";